import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncMaterialIconFilled = createAsyncIcon(() => import('./MaterialIconFilled'));

export default AsyncMaterialIconFilled;

AsyncMaterialIconFilled.displayName = 'AsyncMaterialIconFilled';
